<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container-fluid accordion-container mt-3 accordion-inner">
  <mat-accordion class="accordion" multi>
    <mat-expansion-panel [expanded]="accordionOpened">
      <mat-expansion-panel-header class="py-2">
        <mat-panel-title>
          {{ question?.question }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *ngIf="question?.description" class="mb-5">
        <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3">{{ "generic.description" | translate }}</h4>
        <p class="formatted">{{ question?.description }}</p>
      </div>

      <ng-container *ngIf="timelineIsEnabled; else elseBlock">

        <div class="container my-3">
          <h5 class="mb-3">{{ "components.surveys.question-history-dashboard.select-surveys-to-compare" | translate }}
            :</h5>
          <div class="row">
            <div class="col-12 col-md-4" *ngFor="let s of surveys">
              <mat-checkbox
                class="my-2"
                [checked]="surveysToCompare.includes(s)"
                (change)="toggleSurveyComparison(s, $event.checked)"
              >
                Survey {{ s.version_number }}
              </mat-checkbox>
            </div>
          </div>
        </div>

        <div class="container mt-4">
          <div class="row g-4 justify-content-start">
            <div
              *ngFor="let s of surveysToCompare"
              class="col-12"
            >
              <mat-card class="h-100 shadow-sm">
                <mat-card-header>
                  <mat-card-title>
                    v{{ s.version_number }}
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>

                  <app-single-question-responses
                    [viewOnlyChart]="true"
                    [questionID]="s?.survey_question?.id"
                  >
                  </app-single-question-responses>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #elseBlock>
        <div echarts [options]="chartOptions" (chartClick)="onChartClick($event)" class="w-full h-100 my-3"></div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
